import React from 'react';
import styled from 'styled-components';

import bannerMobile from '../../images/examCenterReferralReviewBannerMobile.webp';
import bannerMobile2x from '../../images/examCenterReferralReviewBannerMobile@2x.webp';
import banner from '../../images/examCenterReferralReviewBanner.webp';
import banner2x from '../../images/examCenterReferralReviewBanner@2x.webp';
import media from '../../utils/mediaQueries';

const Image = styled.img`
  max-width: 100%;
  height: auto;
  margin: 8px 0 48px;

  ${media.mobile`
    margin: 16px 0 32px;
  `}
`;

const Intro = ({ city }: { city: string }) => (
  <>
    {`Bravo encore pour l’obtention de votre code. Maintenant, place à la conduite. VroomVroom continue à vous accompagner en vous mettant en relation avez une auto-école proche de ${city} et en vous faisant profiter de tarifs préférentiel !`}
    <picture>
      <source
        media="(max-width: 997px)"
        srcSet={`${bannerMobile} 1x, ${bannerMobile2x} 2x`}
      />
      <source
        media="(min-width: 998px)"
        srcSet={`${banner} 1x, ${banner2x} 2x`}
      />
      <Image
        src={banner}
        alt="Économisez jusqu'à 100€ sur votre formation"
      />
    </picture>
    <div>Laissez nous vos coordonnées ci-dessous afin d’être contacté(e).</div>
  </>
);

export { Intro };
